// extracted by mini-css-extract-plugin
export default {"element":"ImageCentered-module--element--9844b","small":"ImageCentered-module--small--875c3"};